import React, {Component} from 'react';
import Main from '../widgets/Main';
import TabSet from '../widgets/TabSet';
import RouteLink from '../widgets/RouteLink';
import SetDetails from './SetDetails';
import {Route} from 'react-router';
import {connect} from 'react-redux';
import VersionDetails from './VersionDetails';
import VersionPreview from './VersionPreview';
import Actions from '../widgets/Actions';
import {actions} from './syllabus.state'
import SubtleMessage from '../widgets/SubtleMessage';
import {
	canSave as canSaveVersion, getSelectedVersionID, getThisVersion, isRetrieving,
	isVersionSaving
} from './version.selectors';
import {canSaveSet, getSelectedSet, getSelectedSetID, isSetSaving, setRetrievingSelector} from './set.selectors';
import NotFound from '../widgets/NotFound';
import jsonFetch from '../jsonFetch';
import handleError from '../handleError';
import Loading from '../widgets/Loading';

export class SyllabusPage extends Component {
	constructor(props) {
		super(props);
		
		this.state = {initialLastSaveSet: props.lastSaveSet, initialLastSaveVersion: props.lastSaveVersion};
		
		this.getVersion(props.setID, props.versionID, props.selectedVersion);
	}
	
	componentWillReceiveProps(nextProps) {
		// If the version selection changes, OR we previously had no selected version object at all and now we do (i.e. list is loaded)
		if (this.props.versionID !== nextProps.versionID || (!this.props.selectedVersion && this.props.selectedVersion !== nextProps.selectedVersion)) {
			this.getVersion(nextProps.setID, nextProps.versionID, nextProps.selectedVersion);
		}
	}
	
	/**
	 * Retrieve the detailed items for a given version.
	 */
	getVersion = (setID, versionID, selectedVersion) => {
		if (!selectedVersion || !setID || !versionID) return; // We can only get details if something is selected and the list is loaded
		
		jsonFetch(`${process.env.REACT_APP_API}/set/${setID}/version/${versionID}`)
			.then(json => setID === this.props.setID && versionID === this.props.versionID && this.props.itemsRetrieved(json.items))
			.catch(handleError)
	};
	
	render() {
		const {
			setID, versionID,
			isDirty, saveSet, saveVersion, lastSaveSet, lastSaveVersion, canSaveVersion, canSaveSet,
			selectedSet, selectedVersion, isSaving, isRetrieving
		} = this.props;
		
		return selectedSet ? (
			<Main className="SyllabusPage">
				{/*Tab set/nav*/}
				<TabSet>
					{versionID ?
						<RouteLink to={`/set/${setID}/version/${versionID}`} activeOnlyWhenExact={true} disabled={isDirty}>Set details</RouteLink> :
						<RouteLink to={`/set/${setID}`} activeOnlyWhenExact={true} disabled={isDirty}>Set details</RouteLink>}
					{versionID && selectedVersion ? <RouteLink to={`/set/${setID}/version/${versionID}/details`} disabled={isDirty}>Version details</RouteLink> : undefined}
					{versionID && selectedVersion ? <RouteLink to={`/set/${setID}/version/${versionID}/preview`} disabled={isDirty}>Preview</RouteLink> : undefined}
				</TabSet>
				
				{/*Page body*/}
				<Route path="/set/:setID" exact component={SetDetails} />
				<Route path="/set/:setID/version/:versionID" exact component={SetDetails} />
				<Route path="/set/:setID/version/:versionID/details" component={VersionDetails} />
				<Route path="/set/:setID/version/:versionID/preview" component={VersionPreview} />
				
				{/*Page actions*/}
				<Route path="/set/:setID" exact render={() => (
					isSaving ? (<Loading noflex={true} />) : (<Actions
						disabledActions={canSaveSet ? [] : ['Save']}
						isDirty={canSaveSet && isDirty}
						actions={['Cancel', 'Save']}
						positive="Save"
						onClick={saveSet}
					/>)
				)}/>
				{selectedVersion && (<Route path="/set/:setID/version/:versionID" exact render={() => (
					isSaving ? (<Loading noflex={true} />) : (<Actions
						disabledActions={canSaveSet ? [] : ['Save']}
						isDirty={canSaveSet && isDirty}
						actions={['Cancel', 'Save']}
						positive="Save"
						onClick={saveSet}
					/>)
				)}/>)}
				{selectedVersion && (<Route path="/set/:setID/version/:versionID/details" render={() => (
					isSaving ? (<Loading noflex={true} />) : (<Actions
						disabledActions={canSaveVersion ? [] : ['Save']}
						isDirty={canSaveVersion && isDirty}
						actions={['Cancel', 'Save']}
						positive="Save"
						onClick={saveVersion}
					/>)
				)}/>)}
				{/*Key is important to ensure new message renders for each save*/}
				{lastSaveSet && this.state.initialLastSaveSet !== lastSaveSet ? <SubtleMessage key={`set_${lastSaveSet}`} message={`Syllabus set details saved`}/> : undefined}
				{lastSaveVersion && this.state.initialLastSaveVersion !== lastSaveVersion ? <SubtleMessage key={`set_${lastSaveVersion}`} message={`Syllabus version details saved`}/> : undefined}
			</Main>
		) : (isRetrieving ? <Loading /> : <NotFound/>);
	}
}

const ConnectedSyllabusPage = connect(
	(state, ownProps) => ({
		isDirty: !!(state.dirty && state.dirty.keys && Object.keys(state.dirty.keys).length),
		isSaving: isSetSaving(state, ownProps) || isVersionSaving(state, ownProps),
		isRetrieving: setRetrievingSelector(state, ownProps) || isRetrieving(state, ownProps),
		lastSaveSet: state.syllabus && state.syllabus.sets && state.syllabus.sets.lastSave,
		lastSaveVersion: state.syllabus && state.syllabus.versions && state.syllabus.versions.lastSave,
		canSaveVersion: canSaveVersion(state, ownProps),
		canSaveSet: canSaveSet(state, ownProps),
		versionID: getSelectedVersionID(state, ownProps),
		selectedVersion: getThisVersion(state, ownProps),
		setID: getSelectedSetID(state, ownProps),
		selectedSet: getSelectedSet(state, ownProps),
	}),
	(dispatch, {match: {params: {setID, versionID}}}) => ({
		saveSet: action => action === 'Save' ? dispatch(actions.saveSet(setID || 'new')) : dispatch(actions.cancelSet(setID || 'new')),
		saveVersion: action => action === 'Save' ? dispatch(actions.saveVersion(setID, versionID)) : dispatch(actions.cancelVersion(setID, versionID)),
		itemsRetrieved: items => dispatch(actions.versionUpdate({items, versionID})),
	})
)(SyllabusPage);

export default ConnectedSyllabusPage;


// WEBPACK FOOTER //
// ./src/syllabus/SyllabusPage.js